import React, { Component } from "react";
import Styled , { keyframes }from "styled-components";

class SubTitle extends Component {
  constructor() {
    super();
    this.state = {
      subsArr: [
        "Full-Stack Web Developer",
        "Good-Natured",
        "Baseball Aficionado",
        "Dogs Best-Friend",
        "Italian-Food Lover"
      ],
      subTitle: "",
      pos: 0
    };
  }

  componentDidMount() {
    this.setState({ subTitle: this.state.subsArr[0] });
  }

  _interval = setInterval(() => {
    if (this.state.pos < this.state.subsArr.length - 1) {
      this.setState({ pos: this.state.pos + 1 });
    } else if (this.state.pos === this.state.subsArr.length - 1) {
      this.setState({ pos: 0 });
    }
    this.setState({ subTitle: this.state.subsArr[this.state.pos] });
  }, 3000);

  componentWillUnmount() {
    clearInterval(this._interval);
  }

  render() {

    const typing = keyframes`
        from { 
          width: 0; 
        }
    `;

    const blinkCaret = keyframes`
        50% {
         border-color: transparent; 
        
        }
    
    `;

    const SubTitle = Styled.p`
			font-size: 2.5em;
			text-align: center;
      color: palevioletred;
     border-right: 1px solid palevioletred;
     width: 21ch;
    white-space: nowrap;
    overflow: hidden;
    -webkit-animation: ${typing} 2s steps(30, end),
               ${blinkCaret} .5s step-end infinite alternate;
}

			@media (max-width: 700px) {
				font-size: 1.5em;
			}
	`;

    return (
        <SubTitle>{this.state.subTitle}</SubTitle>
    );
  }
}

export default SubTitle;



// WEBPACK FOOTER //
// ./src/Components/SubTitle.jsx